{
  "version": 1,
  "asset_id": "f74e5433-5c32-4153-a976-e4501ed33cb6",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f74e5433-5c32-4153-a976-e4501ed33cb6/hiatal-type-3-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f74e5433-5c32-4153-a976-e4501ed33cb6/hiatal-type-3-v3-800.webp",
  "original_filename": "hiatal-type-3-v3-800.webp",
  "size": 99674,
  "content_type": "image/webp",
  "created_at": "2026-10-28T22:48:27Z"
}
